var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Pipe } from '@angular/core';
import { HayDayItemType, HayDayItems } from '../models/haydayitem';
export var ItemsOfTypePipe = (function () {
    function ItemsOfTypePipe() {
    }
    ItemsOfTypePipe.prototype.transform = function (allItems, type) {
        switch (type) {
            case "Crops":
                allItems = allItems.filter(function (item) { return item.type == HayDayItemType.Crop; });
                allItems.splice(0, 0, HayDayItems.None);
                return allItems;
            case "Products":
                allItems = allItems.filter(function (item) { return item.type == HayDayItemType.Product; });
                allItems.splice(0, 0, HayDayItems.None);
                return allItems;
            case "Tools":
                allItems = allItems.filter(function (item) { return item.type == HayDayItemType.Tool; });
                allItems.splice(0, 0, HayDayItems.None);
                return allItems;
            default:
                return allItems;
        }
    };
    ItemsOfTypePipe = __decorate([
        Pipe({ name: 'ItemsOfType' }), 
        __metadata('design:paramtypes', [])
    ], ItemsOfTypePipe);
    return ItemsOfTypePipe;
}());
export var SearchPipe = (function () {
    function SearchPipe() {
    }
    SearchPipe.prototype.transform = function (allItems, searchText) {
        if (!searchText) {
            return allItems;
        }
        searchText = searchText.toLowerCase();
        return allItems.filter(function (item) {
            if (item.nameLower.indexOf(searchText) > -1) {
                return true;
            }
            return false;
        });
    };
    SearchPipe = __decorate([
        Pipe({ name: 'Search' }), 
        __metadata('design:paramtypes', [])
    ], SearchPipe);
    return SearchPipe;
}());
